import TimeFormatter from "../../../utility/TimeFormatter";

 export const getMeetingDay = (date) => {
            if(!date) return ;
            const userDate = TimeFormatter(date);
            const currentDateObj = new Date();
            const currentDate = currentDateObj.toISOString().split('T')[0]; 
            const tomorrowDate = new Date(currentDateObj);
            tomorrowDate.setDate(currentDateObj.getDate() + 1); 
            const yesterdayDate = new Date(currentDateObj);
            yesterdayDate.setDate(currentDateObj.getDate() - 1); 
        
            const formatTomorrow = tomorrowDate.toISOString().split('T')[0];
            const formatYesterday = yesterdayDate.toISOString().split('T')[0];
        
        
            let time_only = userDate.ShiftTime.split(":")[0];
            let logT = "";
            if (time_only < 10) {
                logT = '0' + time_only + ':' + userDate.ShiftTime.split(":")[1];
            } else {
                logT = userDate.ShiftTime;
            }
        
            let str = '';

            if (userDate.
                ShiftDate === currentDate) {
                str = `Today`;
            } else if (userDate.
                ShiftDate === formatTomorrow) {
                str = `Tomorrow `;
            } else if (userDate.
                ShiftDate === formatYesterday) {
                str = `${logT}`;
            } else {
                str = `${userDate.userSplitedDate[2]} ${userDate.shiftFullMonth}`;
            }
        
            return str;
        };